import React from "react";
import styles from "./modal.module.css";
import { BsXLg } from "react-icons/bs";

const Modal = ({
  isOpen,
  onClose,
  header = null,
  children,
  buttons = [],
  showCloseIcon = true,
  closeIconStyle = {},
  style = {},
  otherStyle = {},
  optionalClasses = "",
  closeOnOverlayClick = true,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      style={otherStyle}
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div
        className={`${styles.modal} ${optionalClasses}`.trim()}
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {header && (
          <div className={styles.header}>
            <div>{header}</div>
            {showCloseIcon && (
              <BsXLg
                onClick={onClose}
                className={styles.closeIcon}
                style={closeIconStyle}
              />
            )}
          </div>
        )}

        {/* Content */}
        <div className={styles.content}>{children}</div>

        {/* Footer */}
        {buttons.length > 0 && (
          <div className={styles.footer}>
            {buttons.map((button, index) => (
              <button
                key={index}
                onClick={button.onClick}
                className={styles.button}
                style={button.style}
              >
                {button.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
